export const ROOT = 'typePublication';

export const FETCH_TYPE_PUBLICATION_REQUEST = `${ROOT}/FETCH_TYPE_PUBLICATION_REQUEST`;
export const FETCH_TYPE_PUBLICATION_FAILURE = `${ROOT}/FETCH_TYPE_PUBLICATION_FAILURE`;
export const FETCH_TYPE_PUBLICATION_SUCCESS = `${ROOT}/FETCH_TYPE_PUBLICATION_SUCCESS`;

export const SET_TYPE_PUBLICATION_SELECTED = `${ROOT}/SET_TYPE_PUBLICATION_SELECTED`;
export const CLEAR_TYPE_PUBLICATION_ALL = `${ROOT}/CLEAR_TYPE_PUBLICATION_ALL`;